import React, { useCallback } from 'react';

import { SUBCATEGORIES } from '../../common/categories';
import { AZURE_CONNECTORS_FIELDS } from '../../common/fields';
import * as actions from '../../containers/Integrations/integrationsActions';

import ArrayContainer from '../Controls/ArrayContainer/ArrayContainer';
import Button from '../Controls/Button/Button';
import Label from '../Controls/Label/Label';
import Description from '../Controls/Description/Description';
import TextInput from '../Controls/TextInput/TextInput';
import AzureConnector from './AzureConnector';

import { CONDITIONS_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import ConventionCreator from '../CustomInsight/ConventionCreator';

const { AZURE_CONNECTORS } = SUBCATEGORIES;
const { AZURE_AD_CONNECTOR, AZURE_REDIRECT_URI, AZURE_AD_NAMING_CONVENTIONS } = AZURE_CONNECTORS_FIELDS;

const AzureConnectors = ({ fields, dispatch, authorizePermission }) => {
    const azureConnectors = fields[AZURE_AD_CONNECTOR.ID];
    const redirectUri = fields[AZURE_REDIRECT_URI.ID];
    const namingConventions = fields[AZURE_AD_NAMING_CONVENTIONS.ID];

    const dispatchAdd = useCallback(() => {
        dispatch({ type: actions.ADD_AZURE_CONNECTOR, payload: { tabKey: AZURE_CONNECTORS.ID } });
    }, [dispatch]);

    const dispatchUpdate = useCallback(
        (fieldId, value) => {
            dispatch({
                type: actions.UPDATE_CONNECTORS_FIELDS,
                payload: { tabKey: AZURE_CONNECTORS.ID, fieldId, value }
            });
        },
        [dispatch]
    );

    const dispatchAddNamingConvention = useCallback(() => {
        dispatch({ type: actions.ADD_NAMING_CONVENTION, payload: { tabKey: AZURE_CONNECTORS.ID } });
    }, [dispatch]);

    const dispatchUpdateArray = useCallback(
        (fieldId, index, arrFieldId, value) => {
            dispatch({
                type: actions.UPDATE_CONNECTOR,
                payload: { tabKey: AZURE_CONNECTORS.ID, fieldId, index, arrFieldId, value }
            });
        },
        [dispatch]
    );

    const dispatchRemove = useCallback(
        (fieldId, index) => {
            if (fieldId === AZURE_AD_CONNECTOR.ID) {
                dispatch({ type: actions.REMOVE_AZURE_CONNECTOR, payload: index });
            } else {
                dispatch({
                    type: actions.REMOVE_NAMING_CONVENTION,
                    payload: { index, tabKey: AZURE_CONNECTORS.ID }
                });
            }
        },
        [dispatch]
    );

    return (
        <>
            {redirectUri && <TextInput field={redirectUri} changed={dispatchUpdate} disabled={!authorizePermission} />}
            {azureConnectors && (
                <div>
                    <Label value={azureConnectors.name} />
                    {azureConnectors.desc && <Description value={azureConnectors.desc} expendDescription={true} />}
                    {azureConnectors.value.map((azureConnector, index) => {
                        return (
                            <ArrayContainer
                                key={AZURE_AD_CONNECTOR.ID + index}
                                header="Entra ID Connector"
                                topSpace={false}
                                remove={() => authorizePermission && dispatchRemove(AZURE_AD_CONNECTOR.ID, index)}>
                                <AzureConnector
                                    azureConnector={azureConnector}
                                    changedFunc={(fId, v) => dispatchUpdateArray(AZURE_AD_CONNECTOR.ID, index, fId, v)}
                                    authorizePermission={authorizePermission}
                                />
                            </ArrayContainer>
                        );
                    })}

                    <Button
                        id="azure-connectors-add-connector-btn"
                        disabled={!authorizePermission}
                        style={{ marginTop: `${azureConnectors.value.length === 0 ? '30px' : '0'}` }}
                        onClick={() => dispatchAdd(AZURE_AD_CONNECTOR.ID)}>
                        + Add Entra ID Connector
                    </Button>
                </div>
            )}

            {namingConventions && (
                <div className="mt-8">
                    <Label value="Match AD Accounts to Entra ID Accounts" />
                    <Description
                        value={
                            'Match Active Directory accounts to their corresponding Entra ID accounts using naming conventions.'
                        }
                        expendDescription={true}
                    />
                    <ConventionCreator
                        title=""
                        NAMING_CONVENTION_FIELD={AZURE_AD_NAMING_CONVENTIONS}
                        namingConventions={namingConventions}
                        addNewNamingConvention={dispatchAddNamingConvention}
                        updateConventionsArray={(index, id, fieldId, v) => dispatchUpdateArray(id, index, fieldId, v)}
                        removeItem={dispatchRemove}
                        filteredOptions={[CONDITIONS_OPTIONS.CONTAINS]}
                    />
                </div>
            )}
        </>
    );
};

export default React.memo(AzureConnectors);
